export const CURRENT_LANGUAGE = 'CURRENT_LANGUAGE';
export const ALLOWED_DEDUCTIBLES = [100000, 200000, 300000, 400000, 500000, 1000000];

export const EMPLOYEE_URLS = ['upgrade-policy', 'home', 'claims', 'profile', 'retail'];

export const EMPLOYER_URLS = ['dashboard', 'members', 'claims', 'settings', 'profile'];
